// src/components/Dashboard/DashboardFilters.jsx
import React, { useState, useEffect } from "react";

const DashboardFilters = ({
  isMobile,
  funcao,
  startDate,
  endDate,
  selectedRepresentative,
  setStartDate,
  setEndDate,
  setSelectedRepresentative,
  gerenteId,
}) => {
  const [representatives, setRepresentatives] = useState([]);

  // Buscando os representantes via API se o usuário for gerente
  useEffect(() => {
    if (funcao === "gerente" && gerenteId) {
      const fetchRepresentatives = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/users/representantes/${gerenteId}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            }
          );
          const data = await response.json();
          // Garantir que data seja um array
          setRepresentatives(Array.isArray(data) ? data : []);
        } catch (error) {
          console.error("Erro ao carregar representantes:", error);
          setRepresentatives([]);
        }
      };

      fetchRepresentatives();
    }
  }, [funcao, gerenteId]);

  const handleRepresentativeChange = (e) =>
    setSelectedRepresentative(e.target.value);

  // Classe para inputs, select e DatePicker com Tailwind
  const inputClass =
    "w-full border border-gray-300 rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500";

  return (
    <div className="rounded-lg">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Data de Início:
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className={inputClass}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Data de Fim:
          </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className={inputClass}
          />
        </div>

        {funcao === "gerente" && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Selecionar Representante:
            </label>
            <select
              value={selectedRepresentative}
              onChange={handleRepresentativeChange}
              className={inputClass}
            >
              <option value="">TODOS REPRESENTANTES</option>
              {(Array.isArray(representatives) ? representatives : []).map(
                (rep) => (
                  <option key={rep.id} value={rep.id}>
                    {rep.id} - {rep.name}
                  </option>
                )
              )}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardFilters;
